<template>
    <div class="tourism tra-flex-col tra-flex-justify-start tra-flex-align-center">
        <div class="tourismContent tra-flex-col tra-flex-justify-start tra-flex-align-center">
            <div class="tourismContentTop tra-flex-row tra-flex-align-center">
                <div class="noticeIcon">
                    <img :src="noticeImg" alt="">
                </div>

                <vue-seamless-scroll
                        :data="arr"
                        class="seamless-warp"
                        :class-option="classOption"
                >
                    <ul class="joinCompanyUl">
                        <li class="scrollLi tra-flex-row tra-flex-align-center" v-for="(item,index) in arr"
                            :key="index">
                            用户
                            <div class="centerName">
                                {{ item.name }}
                            </div>
                            <div class="centerTime">
                                {{ item.content }}
                            </div>
                        </li>
                    </ul>
                </vue-seamless-scroll>

                <div class="signUp">
                    200人已报名
                </div>

                <div class="wantSign">
                    我要报名
                </div>
            </div>

            <div class="charter-select-box">
                <ul class="typeList tra-flex-row tra-flex-align-center">
                    <li :class="typeCurrent == index ? 'typeListAc' : ''" v-for="(item,index) in caseTypeList"
                        :key="index" @click="caseTypeListClick(index)">
                        {{ item }}
                    </li>
                </ul>

                <div class="charter-select-area">
                    <div class="charter-select-area-title-fwqy">
                        出发城市
                    </div>
                    <div class="charter-select-area-list">
                        <div class="area-list-single"
                             v-for="(item,index) in serviceArea"
                             :key="index"
                             @click="serviceAreaClick(index,item)"
                             :class="serviceAreaNumber == index ? 'area-list-single-ac' : ''"
                        >
                            {{ item.name }}
                        </div>
                    </div>
                </div>

                <div class="charter-select-area">
                    <div class="charter-select-area-title">
                        出发时间
                    </div>
                    <div class="charter-select-area-list">
                        <div class="area-list-single"
                             v-for="(item,index) in typeList"
                             :key="index"
                             @click="typeClick(index,item.id,item.text)"
                             :class="typeNumber == index ? 'area-list-single-ac' : ''"
                        >
                            {{ item.text }}
                        </div>
                    </div>
                </div>

                <div class="charter-select-area">
                    <div class="charter-select-area-title">
                        旅游天数
                    </div>
                    <div class="charter-select-area-list">
                        <div class="area-list-single"
                             v-for="(item,index) in natureList"
                             :key="index"
                             @click="natureClick(index,item.text)"
                             :class="natureNumber == index ? 'area-list-single-ac' : ''"
                        >
                            {{ item.text }}
                        </div>
                    </div>
                </div>

                <!--<div class="charter-select-area">
                    <div class="charter-select-area-title">
                        服务保障
                    </div>
                    <div class="charter-select-area-list">
                        &lt;!&ndash;<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"&ndash;&gt;
                                     &lt;!&ndash;@change="handleCheckAllChange">全选&ndash;&gt;
                        &lt;!&ndash;</el-checkbox>&ndash;&gt;
                        <div class="select-all" @click="selectAll"
                             :class="selectAllCheck ? 'area-list-single-ac' : ''">全部
                        </div>
                        <div class="select-all-list">
                            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                                <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
                            </el-checkbox-group>
                        </div>

                    </div>
                </div>-->

                <div class="charter-select-area" v-show="hasSelect">
                    <div class="charter-select-area-title-fwqy">
                        您已选择
                    </div>
                    <div class="charter-select-area-list">
                        <!--<div class="select-list-single"
                             v-for="(item,index) in selectList"
                             :key="index"
                        >
                            <div class="select-list-single-left">
                                {{ item.type }}
                            </div>
                            <div class="select-list-single-right">
                                {{ item.text }}
                            </div>
                            <div class="select-list-single-close">
                                <img src="@/assets/images/tourism/close.png" alt="">
                            </div>
                        </div>-->

                        <div class="select-list-single-box" v-show="tourismStartCity">
                            <div class="select-list-single">
                                <div class="select-list-single-left">
                                    出发城市
                                </div>
                                <div class="select-list-single-right">
                                    {{ tourismStartCity }}
                                </div>
                                <div class="select-list-single-close" @click="delCity()">
                                    <img src="@/assets/images/tourism/close.png" alt="">
                                </div>
                            </div>
                        </div>

                        <div class="select-list-single-box" v-show="tourismStartTime">
                            <div class="select-list-single">
                                <div class="select-list-single-left">
                                    出发时间
                                </div>
                                <div class="select-list-single-right">
                                    {{ tourismStartTime }}
                                </div>
                                <div class="select-list-single-close" @click="delTime()">
                                    <img src="@/assets/images/tourism/close.png" alt="">
                                </div>
                            </div>
                        </div>

                        <div class="select-list-single-box" v-show="tourismDayNumber">
                            <div class="select-list-single">
                                <div class="select-list-single-left">
                                    旅游天数
                                </div>
                                <div class="select-list-single-right">
                                    {{ tourismDayNumber }}
                                </div>
                                <div class="select-list-single-close" @click="delDay()">
                                    <img src="@/assets/images/tourism/close.png" alt="">
                                </div>
                            </div>
                        </div>

                        <div class="clearSelect" @click="clearSelect()">
                            清除筛选
                        </div>
                    </div>
                </div>
            </div>

            <div class="travel-box">
                <div class="list-box">
                    <div class="charter-sort tra-flex-row tra-flex-align-center">
                        <!--循环版本-->
                        <div class="charter-sort-list"
                             v-for="(item,index) in sortList"
                             :key='index'
                             @click="sortClick(index)"
                             :class="sortNumber == index ? 'charter-sort-list-ac' : ''"
                        >
                            <span>{{ item.text }}</span>
                            <!--<img :src="sortNumber == index ? jiangIcon : morenIcon" alt="">-->
                        </div>

                        <!--非循环版本-->
                        <!--<div class="charter-sort-list"
                             :class="sortNumberClick == 0 ? 'charter-sort-list-ac' : ''"
                             @click="sortClickIdx(0)"
                        >
                            <span>综合服务</span>
                            &lt;!&ndash; <img :src="sortNumberClick == 0 ? (downIcon0 ? jiangIcon : shengIcon) : morenIcon" alt=""> &ndash;&gt;
                        </div>
                        <div class="charter-sort-list"
                             :class="sortNumberClick == 1 ? 'charter-sort-list-ac' : ''"
                             @click="sortClickIdx(1)"
                        >
                            <span>服务人数</span>
                            <img :src="sortNumberClick == 1 ? (downIcon1 ? jiangIcon : shengIcon) : morenIcon" alt="">
                        </div>
                        <div class="charter-sort-list"
                             :class="sortNumberClick == 2 ? 'charter-sort-list-ac' : ''"
                             @click="sortClickIdx(2)"
                        >
                            <span>好评率</span>
                            <img :src="sortNumberClick == 2 ? (downIcon2 ? jiangIcon : shengIcon) : morenIcon" alt="">
                        </div>
                        <div class="charter-sort-list"
                             :class="sortNumberClick == 3 ? 'charter-sort-list-ac' : ''"
                             @click="sortClickIdx(3)"
                        >
                            <span>响应速度</span>
                            <img :src="sortNumberClick == 3 ? (downIcon3 ? jiangIcon : shengIcon) : morenIcon" alt="">
                        </div>-->
                    </div>

                    <div class="list-box-area tra-flex-col tra-flex-align-center" v-show="dataList.length">
                        <div class="list-box-area-single tra-flex-row tra-flex-align-center"
                             v-for="(item,index) in dataList"
                             :key="index" @click="todetail(item.id)">
                            <div class="area-single-img">
                                <img :src="item.rotation" alt="">
                            </div>
                            <div class="area-single-right">
                                <div class="area-single-right-tit">
                                    {{ item.title }}
                                </div>
                                <div class="area-single-right-label">
                                    {{ item.small_title }}
                                </div>

                                <div class="area-single-right-feature tra-flex-row tra-flex-align-center">
                                    <div class="area-single-right-feature-sin" v-for="(itemIn,indexIn) in item.signal"
                                         :key="indexIn">
                                        {{ itemIn }}
                                    </div>
                                </div>

                                <div class="area-single-right-bot tra-flex-row tra-flex-align-center tra-flex-justify-between">
                                    <div class="area-single-right-bot-left tra-flex-row tra-flex-align-center">
                                        <div class="detail-box">
                                            <span>出发城市：</span>
                                            <p>{{ item.city_name }}</p>
                                        </div>
                                        <div class="lineCol">|</div>
                                        <div class="detail-box">
                                            <span>游玩时间：</span>
                                            <p>{{ item.travel_days }}天</p>
                                        </div>
                                        <div class="lineCol">|</div>
                                        <div class="detail-box">
                                            <span>报名人数：</span>
                                            <p>{{ item.number_applicants }}人</p>
                                        </div>
                                    </div>
                                    <div class="area-single-right-bot-right tra-flex-row tra-flex-justify-center tra-flex-align-end">
                                        ¥
                                        <div class="moneyNumber">{{ item.adult_price }}</div>
                                        元起
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="page-paging" v-show="dataList.length">
                            <el-pagination
                                    background
                                    @size-change="handleSizeChange"
                                    @current-change="currentPageChange"
                                    :current-page.sync="currentPage"
                                    :page-sizes="[10, 20, 30, 40]"
                                    :page-size="6"
                                    layout="prev, pager, next, jumper"
                                    :total="dataList.length">
                            </el-pagination>
                        </div>
                    </div>

                    <div class="zanwuBox" v-show="!dataList.length">
                        <div class="zanwuBoxArea">
                            <img src="@/assets/images/persondata/null_img_xitong.png" alt="">
                            <span>暂无满足条件的线路，您可以重新筛选！！</span>
                        </div>
                    </div>
                </div>

                <div class="hot-travel">
                    <div class="hot-travel-title">
                        本月热门线路
                    </div>
                    <div class="hot-travel-list">
                        <div class="hot-travel-single" v-for="(item,index) in hotList" :key="index"
                             @click="todetail(item.id)">
                            <div class="hot-travel-single-img">
                                <img :src="item.rotation" alt="">
                                <div class="hot-travel-label">
                                    {{ item.city_name }} · {{ item.travel_type }}
                                </div>
                            </div>

                            <div class="hot-travel-single-tit">
                                {{ item.title }}
                            </div>

                            <div class="hot-travel-single-money tra-flex-row tra-flex-justify-between tra-flex-align-end">
                                <div class="hot-travel-single-money-left">
                                    ¥ {{ item.adult_price }}
                                </div>
                                <div class="hot-travel-single-money-right">
                                    {{ item.number_applicants }} 人已报名
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="zanwuBoxHot" v-show="!hotList.length">
                        <div class="zanwuBoxAreaHot">
                            <img src="@/assets/images/persondata/null_img_xitong.png" alt="">
                            <span>暂无满足条件的线路，您可以重新筛选！！</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import homeNav from '@/components/homeNav';
    import homeFooter from '@/components/homeFooter';
    import vueSeamlessScroll from 'vue-seamless-scroll'
    import {mapGetters} from 'vuex';

    const cityOptions = ['座位险', '可开发票', '可签合同'];
    export default {
        name: "tourism",
        components: {
            homeNav,
            homeFooter,
            vueSeamlessScroll
        },
        data() {
            return {
                noticeImg: require('@/assets/images/tourism/notice.png'),
                arr: [
                    {
                        img: require('@/assets/images/join/home_pic_headPor.png'),
                        name: '黄女士（158****1215）',
                        content: '报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古... 报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古...',
                    },
                    {
                        img: require('@/assets/images/join/01.png'),
                        name: '郑先生（138****1596）',
                        content: '报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古... 报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古...',
                    },
                    {
                        img: require('@/assets/images/join/02.png'),
                        name: '姚女士（188****0369）',
                        content: '报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古... 报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古...',
                    },
                    {
                        img: require('@/assets/images/join/03.png'),
                        name: '康女士（136****0225）',
                        content: ' 报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古... 报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古...',
                    },
                    {
                        img: require('@/assets/images/join/04.png'),
                        name: '江先生（183****4027）',
                        content: '报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古... 报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古...',
                    },
                    {
                        img: require('@/assets/images/join/05.png'),
                        name: '周女士（139****5425）',
                        content: '报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古... 报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古...',
                    },
                    {
                        img: require('@/assets/images/join/06.png'),
                        name: '谢先生（133****8056）',
                        content: '报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古... 报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古...',
                    },
                    {
                        img: require('@/assets/images/join/07.png'),
                        name: '阳女士（138****3625）',
                        content: '报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古... 报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古...',
                    },

                    {
                        img: require('@/assets/images/join/02.png'),
                        name: '周女士（139****5425）',
                        content: '报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古... 报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古...',
                    },
                    {
                        img: require('@/assets/images/join/05.png'),
                        name: '谢先生（133****8056）',
                        content: '报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古... 报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古...',
                    },
                    {
                        img: require('@/assets/images/join/07.png'),
                        name: '阳女士（138****3625）',
                        content: '报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古... 报名了【烟火八市】以城市步行一次还原6中老厦门，逛吃八市古早美食，旧书店淘绝版好书，骑楼茶肆体验地气“茶桌仔”，中山路复古...',
                    },
                ],
                caseTypeList: ['全部类型', '美景探索', '休闲度假', '户外徒步', '美景摄影'],
                typeCurrent: 0,
                serviceArea: [],
                serviceAreaNumber: 0,
                typeList: [
                    {
                        text: '全部',
                        id: 'All'
                    },
                    {
                        text: '1月',
                        id: 'January'
                    },
                    {
                        text: '2月',
                        id: 'February'
                    },
                    {
                        text: '3月',
                        id: 'March'
                    },
                    {
                        text: '4月',
                        id: 'April'
                    },
                    {
                        text: '5月',
                        id: 'May'
                    },
                    {
                        text: '6月',
                        id: 'June'
                    },
                    {
                        text: '7月',
                        id: 'July'
                    },
                    {
                        text: '8月',
                        id: 'August'
                    },
                    {
                        text: '9月',
                        id: 'September'
                    },
                    {
                        text: '10月',
                        id: 'October'
                    },
                    {
                        text: '11月',
                        id: 'November'
                    },
                    {
                        text: '12月',
                        id: 'December'
                    }
                ],
                typeNumber: 0,
                natureList: [
                    {
                        text: '全部'
                    },
                    {
                        text: '1天'
                    },
                    {
                        text: '2天'
                    },
                    {
                        text: '3天'
                    },
                    {
                        text: '4-7天'
                    },
                    {
                        text: '8-9天'
                    },
                    {
                        text: '9天以上'
                    }
                ],
                natureNumber: 0,
                tourismStartCity: '',
                tourismStartTime: '',
                tourismDayNumber: '',
                sortNumberClick: 0,
                sortList: [
                    {
                        text: '综合排序'
                    },
                    {
                        text: '销量优先'
                    },
                    {
                        text: '价格从高到低'
                    },
                    {
                        text: '价格从低到高'
                    },
                ],
                sortNumber: 0,
                dataList: [],
                hotList: [],

                page: '',
                limit: '',
                search: '',
                travel_type: '',
                travel_month: '',
                travel_days_max: '',
                travel_days_min: '',
                sorts: '',
                province_id: '',
                city_id: '',


                morenIcon: require('@/assets/images/charter/screen_icon_moren.png'),
                jiangIcon: require('@/assets/images/charter/screen_icon_jiang.png'),
                shengIcon: require('@/assets/images/charter/screen_icon_sheng.png'),
                currentPage: 1,


                selectList: [],
                selectAllCheck: false,
                checkedCities: [],
                cities: cityOptions,


                addressInfo: '',
                options: [],
                startCity: '',
                endCity: '',
                showCityBox: false,
                spanIndex: [],
                spanText: [],
                itemList: '',
                timeStart: new Date(),
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now();
                    }
                },
                personNum: '',
                formTelephone: '',
                curClick: 0
            }
        },
        mounted() {
            /*this.startCity = this.getcityName;
            this.getCityData();*/
            var that = this;
            /*var city_id = this.getcityId;
            if (city_id) {
                that.changeArea(city_id);
            }*/

            var pro_id = this.getprovinceId;
            if (pro_id) {
                that.changeArea(pro_id);
            }

            that.gettravelList();
            that.gettravelListHot();
        },
        computed: {
            ...mapGetters(['getcityName', 'getcityId', 'getprovinceId', 'getprovinceCitys', 'getcdList', 'getjxList', 'getuserIp']),
            hasSelect() {
                if (this.tourismStartCity || this.tourismStartTime || this.tourismDayNumber) {
                    return true;
                } else {
                    return false;
                }
            },
            classOption() {
                return {
                    step: 0.5, // 数值越大速度滚动越快
                    limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
                    hoverStop: true, // 是否开启鼠标悬停stop
                    direction: 1, // 0向下 1向上 2向左 3向右
                    openWatch: true, // 开启数据实时监控刷新dom
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
                }
            }
        },
        watch: {
            // 此页面不用
            getprovinceId(newVal, oldVal) {
                this.changeArea(newVal);
                this.gettravelList();
                this.gettravelListHot();
            },

            /*getprovinceCitys: {
                deep: true,
                immediate: true,
                handler: (newName, oldName) =>  {
                    console.log(newName);
                }
            }*/
        },
        methods: {
            // 获取旅游线路列表
            gettravelList() {
                // console.log(this.page + '-' + this.limit + '-' + this.search + '-' + this.travel_type + '-' + this.search + '-' + this.travel_month + '-' + this.travel_days_max + '-' + this.travel_days_min + '-' + this.sorts + '-' + this.getprovinceId + '-' + this.city_id);
                // return;

                const loading = this.$loading({
                    lock: true,
                    text: '数据加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$axios.post('/travelList', {
                    page: this.page,
                    limit: this.limit,
                    search: this.search,
                    travel_type: this.travel_type,
                    travel_month: this.travel_month,
                    travel_days_max: this.travel_days_max,
                    travel_days_min: this.travel_days_min,
                    sorts: this.sorts,
                    province_id: this.getprovinceId,
                    city_id: this.city_id
                }).then((res) => {
                    loading.close();
                    res = res.data;
                    if (res.status == 200) {
                        // console.log(res.data);
                        this.dataList = res.data;
                    }
                }).catch((err) => {
                    loading.close();
                });
            },

            // 获取热门路线
            gettravelListHot() {
                this.$axios.post('/travelListHot', {
                    city_id: this.city_id,
                    province_id: this.getprovinceId,
                    limit: ''
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        // console.log(res.data);
                        this.hotList = res.data;
                    }
                }).catch(() => {

                });
            },

            //获取当前省份下的所有城市
            changeArea(pro_id) {
                var that = this;
                that.$axios.post('/provinceToCity', {
                    province_id: pro_id
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        that.serviceArea = [];
                        that.serviceArea.push({id: '', name: '全部'});
                        res.data.forEach((item) => {
                            that.serviceArea.push(item);
                        })
                        // that.saveCityArea({'cityArea': that.serviceArea});
                    } else {
                        this.$message.error('获取城市失败，请刷新！');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },

            // 全部类型切换点击事件
            caseTypeListClick(idx) {
                this.typeCurrent = idx;
                switch (idx) {
                    case 0:
                        this.travel_type = '';
                        break;
                    case 1:
                        this.travel_type = '美景探索';
                        break;
                    case 2:
                        this.travel_type = '休闲度假';
                        break;
                    case 3:
                        this.travel_type = '户外徒步';
                        break;
                    case 4:
                        this.travel_type = '美景摄影';
                        break;
                    default:
                        this.travel_type = '';
                }

                this.gettravelList();
            },

            // 出发城市切换点击事件
            serviceAreaClick(idx, item) {
                this.serviceAreaNumber = idx;
                if (idx == 0) {
                    this.tourismStartCity = '';
                    this.city_id = '';
                } else {
                    this.tourismStartCity = item.name;
                    this.city_id = item.id;
                }
                this.gettravelList();
                this.gettravelListHot();
            },

            // 出发时间切换点击事件
            typeClick(idx, id, text) {
                this.typeNumber = idx;
                /*switch (id) {
                    case 'All':
                        this.tourismStartTime = '';
                        break;
                    case 'January':
                        this.tourismStartTime = text;
                        break;
                    case 'February':
                        this.tourismStartTime = text;
                        break;
                    case 'March':
                        this.tourismStartTime = text;
                        break;
                    case 'April':
                        this.tourismStartTime = text;
                        break;
                    case 'May':
                        this.tourismStartTime = text;
                        break;
                    case 'June':
                        this.tourismStartTime = text;
                        break;
                    case 'July':
                        this.tourismStartTime = text;
                        break;
                    case 'August':
                        this.tourismStartTime = text;
                        break;
                    case 'September':
                        this.tourismStartTime = text;
                        break;
                    case 'October':
                        this.tourismStartTime = text;
                        break;
                    case 'November':
                        this.tourismStartTime = text;
                        break;
                    case 'December':
                        this.tourismStartTime = text;
                        break;
                    default:
                        this.tourismStartTime = '';
                }*/

                switch (idx) {
                    case 0:
                        this.tourismStartTime = '';
                        this.travel_month = '';
                        break;
                    case 1:
                        this.tourismStartTime = text;
                        this.travel_month = 1;
                        break;
                    case 2:
                        this.tourismStartTime = text;
                        this.travel_month = 2;
                        break;
                    case 3:
                        this.tourismStartTime = text;
                        this.travel_month = 3;
                        break;
                    case 4:
                        this.tourismStartTime = text;
                        this.travel_month = 4;
                        break;
                    case 5:
                        this.tourismStartTime = text;
                        this.travel_month = 5;
                        break;
                    case 6:
                        this.tourismStartTime = text;
                        this.travel_month = 6;
                        break;
                    case 7:
                        this.tourismStartTime = text;
                        this.travel_month = 7;
                        break;
                    case 8:
                        this.tourismStartTime = text;
                        this.travel_month = 8;
                        break;
                    case 9:
                        this.tourismStartTime = text;
                        this.travel_month = 9;
                        break;
                    case 10:
                        this.tourismStartTime = text;
                        this.travel_month = 10;
                        break;
                    case 11:
                        this.tourismStartTime = text;
                        this.travel_month = 11;
                        break;
                    case 12:
                        this.tourismStartTime = text;
                        this.travel_month = 12;
                        break;
                    default:
                        this.tourismStartTime = '';
                        this.travel_month = '';
                }
                this.gettravelList();
            },

            //旅游天数切换点击事件
            natureClick(idx, text) {
                this.natureNumber = idx;
                if (idx == 0) {
                    this.tourismDayNumber = '';
                } else {
                    this.tourismDayNumber = text;
                }

                switch (idx) {
                    case 0:
                        this.travel_days_min = '';
                        this.travel_days_max = '';
                        break;
                    case 1:
                        this.travel_days_min = 0;
                        this.travel_days_max = 1;
                        break;
                    case 2:
                        this.travel_days_min = 0;
                        this.travel_days_max = 2;
                        break;
                    case 3:
                        this.travel_days_min = 0;
                        this.travel_days_max = 3;
                        break;
                    case 4:
                        this.travel_days_min = 4;
                        this.travel_days_max = 7;
                        break;
                    case 5:
                        this.travel_days_min = 8;
                        this.travel_days_max = 9;
                        break;
                    case 6:
                        this.travel_days_min = 9;
                        this.travel_days_max = 100;
                        break;
                    default:
                        this.travel_days_min = '';
                        this.travel_days_max = '';
                }
                this.gettravelList();
            },

            // 清除选中出发城市
            delCity() {
                this.tourismStartCity = '';
                this.serviceAreaNumber = 0;
                this.city_id = '';
                this.gettravelList();
            },

            // 清除选中的出游时间
            delTime() {
                this.tourismStartTime = '';
                this.typeNumber = 0;
                this.travel_month = '';
                this.gettravelList();
            },

            // 清除选中的天数
            delDay() {
                this.tourismDayNumber = '';
                this.natureNumber = 0;
                this.travel_days_max = '';
                this.travel_days_min = '';
                this.gettravelList();
            },

            // 清除筛选
            clearSelect() {
                this.tourismStartCity = '';
                this.tourismStartTime = '';
                this.tourismDayNumber = '';

                this.serviceAreaNumber = 0;
                this.typeNumber = 0;
                this.natureNumber = 0;

                this.city_id = '';
                this.travel_month = '';
                this.travel_days_max = '';
                this.travel_days_min = '';
                this.gettravelList();
            },

            // 排序点击事件
            sortClick(idx) {
                this.sortNumber = idx;
                if (idx == 0) {
                    // console.log('综合排序');
                    this.sorts = 'zhsort';
                } else if (idx == 1) {
                    // console.log('销量优先');
                    this.sorts = 'consumesort';
                } else if (idx == 2) {
                    // console.log('价格从低到高');
                    this.sorts = 'hidepricesort';
                } else if (idx == 3) {
                    // console.log('价格从高到低');
                    this.sorts = 'lowpricesort';
                } else {
                    this.sorts = '';
                }

                this.gettravelList();
            },

            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            currentPageChange(val) {
                console.log(`当前页: ${val}`);
            },


            // 多选框切换事件
            handleCheckedCitiesChange(value) {
                var that = this;
                let checkedCount = value.length;
                that.checkArr = value;
                this.checkAll = checkedCount === this.cities.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
                this.selectAllCheck = checkedCount === this.cities.length;
                //改变事件
                var zwx = '';
                var fp = '';
                that.checkArr.forEach((item) => {
                    if (item == '座位险') {
                        zwx = 1;
                    }
                    if (item == '可开发票') {
                        fp = 1;
                    }
                })
                var gsxz;
                if (that.natureNumber == 0) {
                    gsxz = '';
                } else {
                    gsxz = that.natureNumber;
                }
                if (that.sortNumberClick == 0) {
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 1) {
                    var sort_type;
                    that.downIcon1 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        serverNum: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 2) {
                    var sort_type;
                    that.downIcon2 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        PraiseRate: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 3) {
                    var sort_type;
                    that.downIcon3 ? sort_type = 'asc' : sort_type = 'desc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        response_speed: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                }
            },
            // 全选点击事件
            selectAll() {
                var that = this
                this.checkedCities = cityOptions;
                this.selectAllCheck = true;
                //改变事件
                if (this.selectAllCheck) {
                    var zwx = 1;
                    var fp = 1;
                } else {
                    var zwx = '';
                    var fp = '';
                }
                var gsxz;
                if (that.natureNumber == 0) {
                    gsxz = '';
                } else {
                    gsxz = that.natureNumber;
                }
                if (that.sortNumberClick == 0) {
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 1) {
                    var sort_type;
                    that.downIcon1 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        serverNum: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 2) {
                    var sort_type;
                    that.downIcon2 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        PraiseRate: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 3) {
                    var sort_type;
                    that.downIcon3 ? sort_type = 'asc' : sort_type = 'desc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        response_speed: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                }
            },

            // 旅游详情
            todetail(id) {
                this.$router.push({path: '/tourismDetail', query: {id: id}});
                /*var cidgid = idx + "_" + id;
                this.$router.push({name: "TravelDetail", params: {cidgid: cidgid + ".html"}});*/
            },


            getCityData() {
                var that = this;
                that.$axios.get('/provinceAndCity', {}).then((res) => {
                    res = res.data;
                    // console.log(res.data)
                    if (res.status == 200) {
                        that.options = res.data;
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message('系统错误，请刷新！');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }
</script>

<style scoped>
    @import './tourism.css';
</style>



// WEBPACK FOOTER //
// src/pages/tourism/tourism.vue